import MojitoCore from 'mojito/core';
import DataProvidersTypes from 'services/sports-content/content-provider/types.js';

const { DataProvider } = MojitoCore.Services;
const {
    MenusProvider: { COLLECTION_NAME },
} = DataProvidersTypes;

/**
 *
 * Class offering the possibility to link to sports content menus information.
 *
 * @class MenusProvider
 * @extends Mojito.Core.Services.DataProvider
 * @memberof Mojito.Services.SportsContent.DataProviders
 */
class MenusProvider extends DataProvider {
    init(languageCode) {
        super.addSimpleCollection(COLLECTION_NAME, languageCode);
    }

    /**
     * Link to specific sport menu.
     *
     * @param {string} sportMenuId - The sport menu list id.
     * @param {Function} setter - Function called when the requested data is updated.
     * @returns {object} Subscription that must be disposed when no longer needed.
     * @function Mojito.Services.SportsContent.Menus.SportMenusProvider#subscribeToEntity
     */
    subscribeToEntity(sportMenuId, setter) {
        return super.subscribeToEntity(sportMenuId, setter, COLLECTION_NAME);
    }
}

export default new MenusProvider();
